import { render, staticRenderFns } from "./ct-project-2.vue?vue&type=template&id=ca5c7c88&scoped=true"
import script from "./ct-project-2.vue?vue&type=script&lang=js"
export * from "./ct-project-2.vue?vue&type=script&lang=js"
import style0 from "./ct-project-2.vue?vue&type=style&index=0&id=ca5c7c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5c7c88",
  null
  
)

export default component.exports